import type { ReactNode } from "react";

export function Th({ children }: { children: ReactNode }) {
  return <th>{children}</th>;
}

export function Td({ children, className }: { children: ReactNode; className?: string }) {
  return <td className={className}>{children}</td>;
}
